import { StickyControlled } from '@mc/design-system'
import { useReserveBottomBarSpace } from 'components/Sticky/useReserveBottomBarSpace'
import { QuizMachineContext } from '../../context'
import { LOGO_ANIMATION_DELAY } from '../../steps/PersonalizedWayfinding'
import { NextEventParameters } from '../../types'
import { ButtonGroup } from './ButtonGroup'

export type BackAndNextButtonsProps = {
  disabled?: boolean
  disabledText?: string
  onNext?: () => void
  machineEvent?: NextEventParameters
  animateOut?: boolean
  setInAnimation?: (inAnimation: boolean) => void
}

export const BackAndNextButtons = ({
  machineEvent,
  disabled = false,
  disabledText = '',
  onNext,
  animateOut = false,
  setInAnimation,
}: BackAndNextButtonsProps) => {
  const actor = QuizMachineContext.useActorRef()
  const stickyBarRef = useReserveBottomBarSpace()

  const handleNext = (force?: boolean) => {
    if (animateOut && !force) {
      // wait some time before sending the screen transition to wait for the ease out animation
      setInAnimation?.(true)
      setTimeout(() => handleNext(true), LOGO_ANIMATION_DELAY)
    } else {
      onNext?.()
      actor.send({ type: 'next', params: machineEvent })
    }
  }

  return (
    <>
      <div className='d-none d-md-block'>
        <ButtonGroup
          disabled={disabled}
          disabledText={disabledText}
          onNext={handleNext}
        />
      </div>

      {/* Mobile Button */}
      <div className='d-md-none'>
        <StickyControlled show ref={stickyBarRef}>
          <ButtonGroup
            disabled={disabled}
            disabledText={disabledText}
            onNext={handleNext}
            isMobile
          />
        </StickyControlled>
      </div>
    </>
  )
}
